var React = require('react');

function Licensed (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0-Licensed{fill:none;stroke:#EE2F79;stroke-width:2.9374;stroke-miterlimit:10;}\n\t.st1-Licensed{fill:none;stroke:#EE2F79;stroke-width:2.9374;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n"),React.createElement("g",{"key":1},[React.createElement("circle",{"className":"st0-Licensed","cx":"18","cy":"18","r":"12.2","key":0}),React.createElement("polyline",{"className":"st1-Licensed","points":"13,18.1 16.7,21.8 23.7,14.8 \t","key":1})])]);
}

Licensed.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 36 36","style":{"enableBackground":"new 0 0 36 36"},"xmlSpace":"preserve"};

module.exports = Licensed;

Licensed.default = Licensed;
